import BaseItem, { Rarity } from './base_item';
import Fireling from './moveable/fireling';

export default class Fire extends BaseItem {
    constructor(x, y) {
        super(x, y, "effects", "fire_01.png");
        this.anchor.set(0.5, 0.5);
        this.shadow.alpha = 0;
        this.animations.add('fire', Phaser.Animation.generateFrameNames('fire_', 1, 5, '.png', 2), 12, true).play();
        this.flameTimer = 6 * 1000;
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15; }
    static get height() { return 8; }

    static get mass() { return 3; }
    static get rarity() { return Rarity.RARE; }
    static get electronic() { return false; }

    update() {
        this.flameTimer -= game.time.physicsElapsedMS;
        if (this.flameTimer <= 0) {
            this.spawnFlame();
             this.flameTimer = 6 * 1000;
        }
        super.update();
    }

    spawnFlame() {
        this.spawnReady = new Fireling(this.x, this.y);
    }

    static get type() { return 'fire' }
    static get label() { return 'Fire' }
    static get description() {
        return game.rnd.pick([
            `OH MY GOD IT BURNS!`,
            `Ouch!`,
            `I guess I don't need eyebrows anymore. Or fingers.`,
            `My fingers are melting!`,
            `hot hOT HOT HOT!`,
            `*sizzling*`,
        ])
    }
}


// WEBPACK FOOTER //
// ./src/objects/items/fire.js